import React, { useState, useRef, useCallback } from "../../../__compat__/react/main.entry.mjs.mjs";
import { addMonths, subMonths } from "../../../__compat__/date-fns/main.entry.mjs.mjs";
import { CalendarMonth, CalendarWeek } from "../Calendar/index.mjs.mjs";
import { CalendarHeader } from "../CalendarHeader/index.mjs.mjs";
import { YearSelect } from "../YearSelect/index.mjs.mjs";
import { isMonthWithinInterval } from "../dateHelpers.mjs.mjs";
import { StyledContainer, StyledHeaderContainer, StyledBodyContainer, } from "./SingleCalendar.styles.mjs.mjs";
export const SingleCalendar = ({ autoFocusSelected, getDateProps, id, month, minDate, maxDate, closeAfterSelection, onClickDate: handleClickDate, onKeyDownDate: handleKeyDownDate, onKeyPressDate: handleKeyPressDate, onKeyUpDate: handleKeyUpDate, onMonthChange: handleMonthChange, onMouseEnterDate: handleMouseEnterDate, onSelection, }) => {
    const [open, setOpen] = useState(false);
    const yearSelectorButtonRef = useRef(null);
    const interval = { start: minDate, end: maxDate };
    const currentMonthDisabled = !isMonthWithinInterval(month, interval);
    const yearSelectId = `${id}-year-select`;
    const shouldDisablePrevious = 
    // to prevent getting locked in an invalid month the current month must not be disabled
    !currentMonthDisabled &&
        !isMonthWithinInterval(subMonths(month, 1), interval);
    const shouldDisableNext = !currentMonthDisabled &&
        !isMonthWithinInterval(addMonths(month, 1), interval);
    const dispatchMonthChange = useCallback((action) => {
        switch (action.type) {
            case 'decrement':
                handleMonthChange(subMonths(month, 1));
                break;
            case 'increment':
                handleMonthChange(addMonths(month, 1));
                break;
            default:
                throw new Error('Dispatcher called without type');
        }
    }, [handleMonthChange, month]);
    const handleDateClick = (date, event) => {
        handleClickDate && handleClickDate(date, event);
        closeAfterSelection && onSelection && onSelection();
    };
    return (React.createElement(StyledContainer, null,
        React.createElement(StyledHeaderContainer, null,
            React.createElement(CalendarHeader, { month: month, disableNext: shouldDisableNext, disablePrevious: shouldDisablePrevious, onPrevious: () => {
                    dispatchMonthChange({ type: 'decrement' });
                }, onNext: () => {
                    dispatchMonthChange({ type: 'increment' });
                }, open: open, onToggleSelect: () => setOpen(!open), yearSelectId: yearSelectId, yearSelectRef: yearSelectorButtonRef })),
        React.createElement(StyledBodyContainer, null, open ? (React.createElement(YearSelect, { value: month, onChange: handleMonthChange, "aria-labelledby": yearSelectId, spaceStackStart: "xl" })) : (React.createElement(React.Fragment, null,
            React.createElement(CalendarWeek, null),
            React.createElement(CalendarMonth, { autoFocusSelected: autoFocusSelected, month: month, onClickDate: handleDateClick, onKeyDownDate: handleKeyDownDate, onKeyUpDate: handleKeyUpDate, onKeyPressDate: handleKeyPressDate, onMouseEnterDate: handleMouseEnterDate, getDateProps: getDateProps }))))));
};
//# sourceMappingURL=SingleCalendar.mjs.mjs.map